import { UserToken } from '@/app/auth/types/userToken.type';
import { AUTH_CONSTANTS } from '../constants/auth.constants';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { User } from '@/app/auth/types/user.type';

@Injectable({
  providedIn: 'root',
})
export class AuthHelper {
  constructor(@Inject(DOCUMENT) private _doc: Document) {}

  public getUserToken(): UserToken | null {
    const localStorage = this._doc.defaultView?.localStorage;
    if (!localStorage) return null;
    const userTokenItem = localStorage.getItem(AUTH_CONSTANTS.TOKEN_STORAGE_ITEM);

    if (!userTokenItem) return null;

    return JSON.parse(userTokenItem);
  }

  public isUserLogged(): boolean {
    return this.getUserToken()?.user !== undefined && this.isTokenValid();
  }

  public isTokenValid(): boolean {
    const userToken = this.getUserToken();
    if (!userToken) return false;
    if (!userToken.userToken || !userToken.user) return false;
    if (!userToken.expirationDate || userToken.expirationDate < new Date()) {
      this.logoutSession();
      return false;
    }

    return true;
  }

  public logoutSession(): void {
    const localStorage = this._doc.defaultView?.localStorage;
    if (localStorage) localStorage.clear();
  }

  public saveSession(value: UserToken): void {
    const localStorage = this._doc.defaultView?.localStorage;
    if (localStorage)
      localStorage.setItem(AUTH_CONSTANTS.TOKEN_STORAGE_ITEM, JSON.stringify(value));
  }

  public getUserId(): number | null {
    const userToken = this.getUserToken();
    return userToken?.user?.id || null;
  }

  public saveProfile(value: User): void {
    const authToken = this.getUserToken();
    if (authToken) {
      authToken.user = value;
      this.saveSession(authToken);
    }
  }

  public setUserToken(token: string): void {
    const localStorage = this._doc.defaultView?.localStorage;
    if (localStorage)
      localStorage.setItem(AUTH_CONSTANTS.TOKEN_STORAGE_ITEM, token);
  }
}
